import { Bugfender } from '@bugfender/sdk';
import _axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

import { TOKEN_TYPE_BEARER } from '@/constants/api';
import {
  LS_TOKEN_EXPIRES_AT_KEY,
  LS_TOKEN_KEY,
  SS_LAST_ACTIVITY_AT,
} from '@/constants/common';
import { VITE_BASE_API_URL } from '@/constants/configs';

import { readLocal, removeLocal, removeSessionStorage } from '@/utils/browser';

export type RetriableRequestConfig = InternalAxiosRequestConfig & {
  _retryByRefresh?: boolean;
};

export const axios = _axios.create({
  baseURL: VITE_BASE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // .. other options
});

const token = readLocal(LS_TOKEN_KEY);

if (token) {
  axios.defaults.headers.common['Authorization'] =
    `${TOKEN_TYPE_BEARER} ${token}`;
}

function clearAuthToken() {
  removeLocal(LS_TOKEN_KEY);
  removeLocal(LS_TOKEN_EXPIRES_AT_KEY);
  removeSessionStorage(SS_LAST_ACTIVITY_AT);
  axios.defaults.headers.common['Authorization'] = undefined;
}

export function getTenantFromRequestConfig(config?: RetriableRequestConfig) {
  return (
    config?.headers?.['x-tenant'] ?? axios.defaults.headers.common['x-tenant']
  );
}

axios.interceptors.response.use(
  response => response,
  async function (error: AxiosError) {
    const statusCode = error.response?.status;

    if (statusCode === 401 || statusCode === 403) {
      clearAuthToken();
    } else if (error.response) {
      Bugfender.error('payload', error.response.data);
    } else if (error.request) {
      Bugfender.error('request', error.request);
    } else {
      Bugfender.error('request', error.message);
    }

    throw error;
  },
);
